//
// Signout.js
// - ------------------------------------------------------
// - Functions to support the Signout page
// - ------------------------------------------------------
//
import { signOut } from "./auth.js";

signOut();
